<!-- 
Buttons for changing the status of a provider contact.
-->
<template>
  <span>
    <v-btn v-if="isVslAvailable" color="primary" flat @click="showVslDialog=true">
      <v-icon class="mr-2">edit</v-icon>
      {{ filtered ? "Change Status" : "Change VET Status" }}
    </v-btn>
    
    <v-btn v-if="isHelpAvailable" color="primary" flat @click="showHelpDialog=true">
      <v-icon class="mr-2">edit</v-icon>
      {{ filtered ? "Change Status" : "Change HE Status" }}
    </v-btn>

    <provider-contact-status-dialog v-model="showVslDialog" :contact-id="contact.id" :contact-status-type="'VET'" />
    <provider-contact-status-dialog v-model="showHelpDialog" :contact-id="contact.id" :contact-status-type="'HE'" />

  </span>
</template>

<script>
import ProviderContactStatusDialog from "@/components/provider-contacts/ProviderContactStatusDialog.vue";
export default {
  components: { ProviderContactStatusDialog },
  props: {
    contact: {
      type: Object,
      required: true
    },
    levyCollectionType: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      showVslDialog: false,
      showHelpDialog: false
    };
  },
  computed: {
    state() {
      return this.$store.state.providerContacts.changeStatus;
    },
    isVslAvailable() {
      return !this.filtered || this.levyCollectionType == "Vsl";
    },
    isHelpAvailable() {
      return !this.filtered || this.levyCollectionType == "Help" || this.levyCollectionType == "Upfront";
    },
    filtered() {
      return this.levyCollectionType != null;
    }
  },
  methods: {}
};
</script>
